import { ILabelDesignerTemplateDTO, ILabelDesignerTemplateViewDTO } from "../../libs/coreapi-dto/dirs/labelDesignerTemplate";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class LabelDesignerTemplateDataProvider extends DictionaryDataProvider<ILabelDesignerTemplateViewDTO, ILabelDesignerTemplateDTO> {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ILabelDesignerTemplateViewDTO, ILabelDesignerTemplateDTO>> {
        return this._coreApiService.labelDesignerTemplateRequest
    }
}